import axios from 'axios';
import { runInAction, makeAutoObservable, action } from 'mobx';
import { findIndex, filter } from 'lodash';

export interface ICategory {
  id: number;
  title: string;
  parentId?: string | number;
  children?: ICategory[];
  value?: number | string;
}

export interface ICategoriesStore {
  categories: ICategory[];
  isLoading: boolean;

  postCategory(data: Partial<ICategory>): Promise<void>;
  editCategory(data: ICategory): Promise<void>;
  deleteCategory(uuid: number): Promise<void>;
}

export default class CategoriesStore implements ICategoriesStore {
  categories: ICategory[] = [];
  isLoading = false;

  constructor() {
    makeAutoObservable(this);
  }

  @action
  async postCategory(data: Partial<ICategory>) {
    const result = await axios.post('/api/category', data);
    runInAction(() => {
      this.categories.push(result?.data);
    });
  }

  @action
  async editCategory(data: ICategory) {
    const result = await axios.put(`/api/category/${data.id}`, data);
    const index = findIndex(this.categories, ['id', data.id]);
    runInAction(() => {
      if (index !== -1) {
        this.categories[index] = result?.data;
      }
    });
  }

  @action
  async deleteCategory(id: number) {
    await axios.delete(`/api/category/${id}`);

    runInAction(() => {
      this.categories = filter(this.categories, (x) => x.id !== id);
    });
  }
}
